import styled from 'styled-components';

const Wrapper = styled.section`
  background: #fff;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  padding: 2rem 1.75rem 2.5rem;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.06);

  h3 {
    font-size: 1.2rem;
    font-weight: 700;
    color: #0f172a;
    letter-spacing: -0.02em;
    text-transform: capitalize;
    margin-top: 0;
    margin-bottom: 1.5rem;
  }

  .form {
    margin: 0;
    border-radius: 0;
    box-shadow: none;
    padding: 0;
    max-width: 100%;
    width: 100%;
    background: transparent;
    border: none;
  }

  .form-label {
    font-size: 0.78rem;
    font-weight: 600;
    color: #64748b;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    margin-bottom: 0.35rem;
    display: block;
  }

  .form-input,
  .form-select {
    width: 100%;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 9px;
    padding: 0.6rem 0.875rem;
    font-size: 0.875rem;
    color: #0f172a;
    transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;
    &:focus {
      outline: none;
      border-color: #6366f1;
      background: #fff;
      box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
    }
  }

  .form-row {
    margin-bottom: 0;
  }

  .form-center {
    display: grid;
    row-gap: 1rem;
    column-gap: 1.25rem;
  }

  .btn {
    padding: 0.6rem 1.25rem;
    border: none;
    border-radius: 9px;
    font-size: 0.85rem;
    font-weight: 700;
    cursor: pointer;
    transition: transform 0.15s, opacity 0.15s;
    text-transform: capitalize;
    &:disabled { opacity: 0.55; cursor: not-allowed; }
  }

  .btn-block {
    width: 100%;
    display: block;
  }

  .submit-btn,
  .btn-block:not(.clear-btn) {
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
    color: #fff;
    box-shadow: 0 3px 14px rgba(99, 102, 241, 0.3);
    &:hover:not(:disabled) { opacity: 0.9; transform: translateY(-1px); }
  }

  .btn-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 0.875rem;
    align-self: flex-end;
    margin-top: 0.5rem;
  }

  .clear-btn {
    background: #f1f5f9;
    color: #475569;
    border: 1px solid #e2e8f0;
    box-shadow: none;
    &:hover:not(:disabled) { background: #e2e8f0; color: #0f172a; }
  }

  @media (min-width: 992px) {
    .form-center {
      grid-template-columns: 1fr 1fr;
      align-items: end;
    }
    .btn-container { margin-top: 0; }
  }

  @media (min-width: 1120px) {
    .form-center { grid-template-columns: 1fr 1fr 1fr; }
  }
`;

export default Wrapper;
